<template>
  <!-- 盒子管理-保低配置-盒子盈亏 -->
  <div v-if="$route.query.pv" class="case_guaranteed_box-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="query.uid" placeholder="请输入盒子id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.name"
            placeholder="请输入盒子名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 200px"
            v-model="query.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          -
          <el-date-picker
            style="width: 200px"
            v-model="query.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="盒子ID" align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="盒子名称"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="" label="盒子盈亏" align="center">
        </el-table-column>
        <el-table-column label="开奖总金额" align="center">
          <template slot-scope="{ row }">
            <span>{{}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="保底开奖金额" align="center">
        </el-table-column>
        <el-table-column prop="" label="保底出奖金额" align="center">
        </el-table-column>
        <el-table-column prop="" label="L1次数" align="center">
        </el-table-column>
        <el-table-column prop="" label="L2次数" align="center">
        </el-table-column>
        <el-table-column prop="" label="L3次数" align="center">
        </el-table-column>
        <el-table-column prop="" label="L4次数" align="center">
        </el-table-column>
        <el-table-column prop="" label="L5次数" align="center">
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" plain @click="toDetails(row)"
              >开箱用户</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import saveFile from '@/utils/saveFile'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1,
        start_time: '',
        end_time: ''
      },
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleExport() {
      let params = this.query
      http
        .post(
          server + '', params,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '保底用户数据.xlsx'
          })
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.case_guaranteed_box-box {
  header {
  }

  .body-box {
  }
}
</style>